import { z } from 'zod';

const componentDisplayDataSchema = z.object({
  ComponentID: z.string(),
  ComponentType: z.string()
});

export { componentDisplayDataSchema };
//# sourceMappingURL=schema.component-display-data.js.map
